/* eslint react/jsx-key: off */
import React from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  NumberInput,
  SelectInput,
  Toolbar,
  SaveButton,
  FormDataConsumer
} from 'react-admin';
import {
  withStyles,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  Divider,
  Paper,
  Avatar,
  TextField,
  Button
} from '@material-ui/core';
import BackButton from '../common/BackButton';
import {apiUrl} from '../../common/Globals';
import {getServiceCategoriesCache, calculateAdvanceAmount} from '../../common/FinancialUtils';

import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import PersonIcon from '@material-ui/icons/Person';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import WorkIcon from '@material-ui/icons/Work';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ImageIcon from '@material-ui/icons/Image';
import DescriptionIcon from '@material-ui/icons/Description';
import BusinessIcon from '@material-ui/icons/Business';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import PaymentIcon from '@material-ui/icons/Payment';

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 16px',
    backgroundColor: '#FAF5FF',
    borderTop: '1px solid #E9D5FF',
    borderRadius: '0 0 10px 10px'
  }
};

const role = localStorage.getItem('role');

const ProjectRequestsEditToolbar = withStyles(toolbarStyles)((props) => {
  const isHistory =
    props.record &&
    props.record.status &&
    String(props.record.status).trim().toLowerCase() === 'history';
  return (
    <Toolbar {...props}>
      <SaveButton disabled={role !== 'admin' || isHistory} variant="contained" color="primary" size="small" />
      <BackButton />
    </Toolbar>
  );
});

const currentStatusList = [
  {id: 'false', name: 'Pending Admin Approval'},
  {id: 'true', name: 'Approved by Admin'}
];

const customStyles = () => ({
  container: {
    padding: '4px'
  },
  headerCard: {
    background: '#FFFFFF',
    color: '#0F172A',
    borderRadius: '8px',
    padding: '8px 12px',
    marginBottom: '8px',
    border: '1px solid #CBD5E1',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.04)'
  },
  headerTitle: {
    fontWeight: 800,
    fontSize: '0.95rem',
    color: '#0F172A',
    lineHeight: 1.2
  },
  statusChipApproved: {
    backgroundColor: '#059669',
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: '0.7rem',
    height: 22
  },
  statusChipPending: {
    backgroundColor: '#D97706',
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: '0.7rem',
    height: 22
  },
  microMetricCard: {
    borderRadius: '6px',
    border: '1px solid',
    padding: '4px 8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '42px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
  },
  microMetricTitle: {
    fontSize: '0.63rem',
    fontWeight: 800,
    letterSpacing: '0.04em',
    lineHeight: 1
  },
  microMetricValue: {
    fontWeight: 900,
    fontSize: '1rem',
    lineHeight: 1.1,
    marginTop: '2px'
  },
  sectionCard: {
    borderRadius: '6px',
    border: '1px solid #CBD5E1',
    boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
    marginBottom: '6px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    height: '100%'
  },
  sectionHeader: {
    backgroundColor: '#F8FAFC',
    borderBottom: '1px solid #CBD5E1',
    padding: '3px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  sectionTitle: {
    fontWeight: 800,
    fontSize: '0.82rem',
    color: '#0F172A'
  },
  sectionContent: {
    padding: '6px 8px !important'
  },
  inputFullWidth: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '5px',
      backgroundColor: '#FFFFFF'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#94A3B8 !important'
    },
    '& .MuiInputBase-input': {
      padding: '5px 8px',
      fontSize: '0.8rem',
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      fontWeight: 600
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      fontWeight: 600,
      opacity: 1
    },
    '& .MuiFormLabel-root': {
      color: '#000000 !important',
      fontWeight: 800,
      backgroundColor: '#FFFFFF',
      padding: '0 3px',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 16px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: '#0F172A !important',
      fontWeight: 800,
      backgroundColor: '#FFFFFF',
      padding: '0 3px',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 16px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  highlightInput: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '5px',
      backgroundColor: '#FAF5FF',
      '& fieldset': {
        borderColor: '#7C3AED',
        borderWidth: '1.5px'
      }
    },
    '& .MuiInputBase-input': {
      padding: '5px 8px',
      fontSize: '0.8rem',
      fontWeight: 700,
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important'
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#000000 !important',
      WebkitTextFillColor: '#000000 !important',
      fontWeight: 700,
      opacity: 1
    },
    '& .MuiSelect-select': {
      fontWeight: 700
    },
    '& .MuiFormLabel-root': {
      color: '#581C87 !important',
      fontWeight: 800,
      backgroundColor: '#FAF5FF',
      padding: '0 3px',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 16px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: '#581C87 !important',
      fontWeight: 800,
      backgroundColor: '#FAF5FF',
      padding: '0 3px',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 16px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  mediaCard: {
    borderRadius: '6px',
    border: '1px solid #CBD5E1',
    padding: '6px',
    backgroundColor: '#F8FAFC',
    textAlign: 'center',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyPlaceholder: {
    color: '#475569',
    fontSize: '0.75rem',
    fontWeight: 600,
    fontStyle: 'italic'
  },
  reqChipTrue: {
    backgroundColor: '#ECFDF5',
    color: '#047857',
    border: '1px solid #6EE7B7',
    fontWeight: 700,
    fontSize: '0.75rem',
    margin: '2px'
  },
  reqChipFalse: {
    backgroundColor: '#F1F5F9',
    color: '#64748B',
    border: '1px solid #CBD5E1',
    fontWeight: 500,
    fontSize: '0.75rem',
    margin: '2px'
  }
});

const resolveUrl = (url) => {
  if (!url) return '';
  if (typeof url === 'object' && url !== null) {
    url = url.src || url.url || url.path || '';
  }
  if (typeof url !== 'string') return '';
  let str = url.trim().replace(/\\/g, '/');
  let lower = str.toLowerCase();
  if (
    !str ||
    lower === 'null' ||
    lower === 'undefined' ||
    lower.endsWith('/null') ||
    lower.endsWith('/undefined')
  ) {
    return '';
  }

  if (str.startsWith('data:') || str.startsWith('blob:')) {
    return str;
  }

  let baseUrl = (apiUrl || 'http://localhost:8085/api').replace(/\/api\/?$/, '');

  const uploadMatch = str.match(/(?:uploads?\/.*)$/i);
  if (uploadMatch) {
    return `${baseUrl}/${uploadMatch[0]}`;
  }

  if (str.startsWith('http://') || str.startsWith('https://')) {
    return str.replace(/https?:\/\/[^/]+/, baseUrl);
  }

  if (str.startsWith('/')) {
    return `${baseUrl}${str}`;
  }

  return `${baseUrl}/${str}`;
};

const calculateFinancials = (record, isAdminApprovedVal, categories = []) => {
  if (!record) return { amountAgreed: 0, amountPaid: 0, balanceAmount: 0, amountRequested: 0, advanceAmount: 0, isApproved: false };

  const isApproved =
    isAdminApprovedVal === true ||
    isAdminApprovedVal === 'true';

  const amountAgreed = parseFloat(
    record.amountToBePaid ??
    record.amount ??
    record.quotationAmount ??
    record.agreedAmount ??
    record.totalAmount ??
    0
  );

  const advanceAmount = calculateAdvanceAmount(record, 'Project', categories);

  let rawAmountPaid = parseFloat(
    record.amountPaid ??
    record.paidAmount ??
    record.amountReceived ??
    0
  );

  let rawAmountRequested = parseFloat(
    record.amountRequested ??
    record.requestedAmount ??
    0
  );

  const wasDbApproved = record.isAdminApproved === true || record.isAdminApproved === 'true';

  let amountRequested = rawAmountRequested;
  if (!wasDbApproved && amountRequested === 0) {
    if (rawAmountPaid > 0) {
      amountRequested = rawAmountPaid;
      rawAmountPaid = 0;
    } else if (advanceAmount > 0) {
      amountRequested = advanceAmount;
    }
  }

  let amountPaid = rawAmountPaid;

  if (isApproved) {
    if (!wasDbApproved && amountRequested > 0) {
      amountPaid = Math.min(amountAgreed, rawAmountPaid + amountRequested);
    }
    amountRequested = 0;
  }

  const balanceAmount = Math.max(0, amountAgreed - amountPaid);

  return { amountAgreed, amountPaid, balanceAmount, amountRequested, advanceAmount, isApproved };
};

const FinancialHighlights = ({record, isAdminApprovedVal, isHistory, classes, categories}) => {
  if (!record) return null;

  const fin = calculateFinancials(record, isAdminApprovedVal, categories);

  return (
    <Box mb={0.5}>
      <Paper className={classes.headerCard} elevation={0}>
        <Box style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '6px', borderBottom: '1px solid #E2E8F0'}}>
          <Box style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <Avatar style={{backgroundColor: '#EEF2FF', color: '#4F46E5', width: 26, height: 26}}>
              <BusinessIcon style={{fontSize: 15}} />
            </Avatar>
            <Typography className={classes.headerTitle}>
              Project Request #{record.id || 'N/A'}
            </Typography>
            <Chip
              size="small"
              label={`${record.customerName || 'N/A'} (${record.mobileNumber || 'N/A'}) • ${record.serviceName || record.serviceCode || 'N/A'}`}
              style={{backgroundColor: '#F1F5F9', color: '#334155', height: 20, fontSize: '0.72rem', fontWeight: 700}}
            />
          </Box>
          <Chip
            size="small"
            icon={
              isHistory || fin.isApproved ? (
                <VerifiedUserIcon style={{color: '#FFF', fontSize: 13}} />
              ) : (
                <HourglassEmptyIcon style={{color: '#FFF', fontSize: 13}} />
              )
            }
            label={isHistory ? 'HISTORY' : fin.isApproved ? 'ADMIN APPROVED' : 'PENDING APPROVAL'}
            className={fin.isApproved || isHistory ? classes.statusChipApproved : classes.statusChipPending}
          />
        </Box>

        {/* 5 Light Color-Coded Micro Metric Cards */}
        <Grid container spacing={1} style={{marginTop: 6}}>
          {/* 1. Amount Agreed */}
          <Grid item xs={6} sm={2} style={{flexBasis: '20%', maxWidth: '20%'}}>
            <Box className={classes.microMetricCard} style={{backgroundColor: '#F0F9FF', borderColor: '#7DD3FC'}}>
              <Typography className={classes.microMetricTitle} style={{color: '#0369A1'}}>
                AMOUNT AGREED
              </Typography>
              <Typography className={classes.microMetricValue} style={{color: '#0C4A6E'}}>₹{fin.amountAgreed.toLocaleString('en-IN')}</Typography>
            </Box>
          </Grid>
          {/* 2. Advance Amount */}
          <Grid item xs={6} sm={2} style={{flexBasis: '20%', maxWidth: '20%'}}>
            <Box className={classes.microMetricCard} style={{backgroundColor: '#ECFEFF', borderColor: '#06B6D4'}}>
              <Typography className={classes.microMetricTitle} style={{color: '#0E7490'}}>
                ADVANCE AMOUNT
              </Typography>
              <Typography className={classes.microMetricValue} style={{color: '#155E75'}}>₹{fin.advanceAmount.toLocaleString('en-IN')}</Typography>
            </Box>
          </Grid>
          {/* 3. Amount Paid */}
          <Grid item xs={6} sm={2} style={{flexBasis: '20%', maxWidth: '20%'}}>
            <Box className={classes.microMetricCard} style={{backgroundColor: '#ECFDF5', borderColor: '#6EE7B7'}}>
              <Typography className={classes.microMetricTitle} style={{color: '#047857'}}>
                AMOUNT PAID
              </Typography>
              <Typography className={classes.microMetricValue} style={{color: '#064E3B'}}>₹{fin.amountPaid.toLocaleString('en-IN')}</Typography>
            </Box>
          </Grid>
          {/* 4. Balance Amount */}
          <Grid item xs={6} sm={2} style={{flexBasis: '20%', maxWidth: '20%'}}>
            <Box className={classes.microMetricCard} style={{backgroundColor: '#FFFBEB', borderColor: '#FDE68A'}}>
              <Typography className={classes.microMetricTitle} style={{color: '#B45309'}}>
                BALANCE AMOUNT
              </Typography>
              <Typography className={classes.microMetricValue} style={{color: '#78350F'}}>₹{fin.balanceAmount.toLocaleString('en-IN')}</Typography>
            </Box>
          </Grid>
          {/* 5. Amount Requested */}
          <Grid item xs={6} sm={2} style={{flexBasis: '20%', maxWidth: '20%'}}>
            <Box className={classes.microMetricCard} style={{backgroundColor: '#FAF5FF', borderColor: '#C4B5FD'}}>
              <Typography className={classes.microMetricTitle} style={{color: '#6D28D9'}}>
                AMOUNT REQUESTED
              </Typography>
              <Typography className={classes.microMetricValue} style={{color: '#4C1D95'}}>₹{fin.amountRequested.toLocaleString('en-IN')}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const CustomDetailsTabContent = ({record, classes}) => {
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    getServiceCategoriesCache().then((cats) => {
      if (cats) setCategories(cats);
    });
  }, []);

  const reqFlags = [
    { label: 'Design Required', key: 'isDesignRequired' },
    { label: 'Material Required', key: 'isMaterialRequired' },
    { label: 'Govt. Approval Required', key: 'isGovermentApprovalRequired' },
    { label: 'Transportation Required', key: 'isTransaportationRequired' },
    { label: 'Construction Only', key: 'isConstructionOnly' },
    { label: 'Testing & Commissioning', key: 'isTestingAndCommissioningRequired' },
    { label: 'Others Required', key: 'isOthersRequired' }
  ];

  return (
    <FormDataConsumer>
      {({ formData }) => {
        const currentRecord = formData || record || {};
        const isHist = Boolean(
          currentRecord.status && String(currentRecord.status).trim().toLowerCase() === 'history'
        );
        const fin = calculateFinancials(currentRecord, currentRecord.isAdminApproved, categories);

        return (
          <Box className={classes.container}>
            <FinancialHighlights
              record={currentRecord}
              isAdminApprovedVal={currentRecord.isAdminApproved}
              isHistory={isHist}
              classes={classes}
              categories={categories}
            />

            {/* ROW 1: 1. Customer Profile & 2. Service Location */}
            <Grid container spacing={1} style={{marginBottom: 8}}>
              {/* 1. Customer Profile */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard}>
                  <Box className={classes.sectionHeader}>
                    <Avatar
                      style={{
                        backgroundColor: '#EEF2FF',
                        color: '#4F46E5',
                        width: 26,
                        height: 26
                      }}
                    >
                      <PersonIcon style={{fontSize: 16}} />
                    </Avatar>
                    <Typography className={classes.sectionTitle}>1. Customer Profile</Typography>
                  </Box>
                  <CardContent className={classes.sectionContent}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="id"
                          label="Request ID"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="customerId"
                          label="Customer ID"
                          format={(v) => (v && typeof v === 'string' ? v.toUpperCase() : (v || ''))}
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="customerName"
                          label="Customer Name"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="mobileNumber"
                          label="Mobile Number"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="emailId"
                          label="Email Address"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="approvedVendorId"
                          label="Approved Vendor ID"
                          format={(v) => (v && typeof v === 'string' ? v.toUpperCase() : (v || ''))}
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* 2. Service Location */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard}>
                  <Box className={classes.sectionHeader}>
                    <Avatar
                      style={{
                        backgroundColor: '#FFF7ED',
                        color: '#EA580C',
                        width: 26,
                        height: 26
                      }}
                    >
                      <LocationOnIcon style={{fontSize: 16}} />
                    </Avatar>
                    <Typography className={classes.sectionTitle}>2. Service Location</Typography>
                  </Box>
                  <CardContent className={classes.sectionContent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <TextInput
                          disabled
                          multiline
                          minRows={2}
                          source="address"
                          label="Street Address"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="localBody"
                          label="Local Body"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="district"
                          label="District"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="state"
                          label="State"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextInput
                          disabled
                          source="pincode"
                          label="Pincode"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* ROW 2: 3. Admin Approval & 4. Project Requirements & Details */}
            <Grid container spacing={1} style={{marginBottom: 8}}>
              {/* 3. Admin Approval & Financial Details */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard} style={{border: '2px solid #7C3AED'}}>
                  <Box
                    className={classes.sectionHeader}
                    style={{
                      backgroundColor: '#FAF5FF',
                      borderBottom: '1.5px solid #E9D5FF'
                    }}
                  >
                    <Avatar
                      style={{
                        backgroundColor: '#7C3AED',
                        color: '#FFF',
                        width: 26,
                        height: 26
                      }}
                    >
                      <AssignmentTurnedInIcon style={{fontSize: 16}} />
                    </Avatar>
                    <Typography className={classes.sectionTitle} style={{color: '#581C87'}}>
                      3. Admin Approval & Financial Details
                    </Typography>
                  </Box>
                  <CardContent className={classes.sectionContent}>
                    <Grid container spacing={1}>
                      <Grid item xs={4}>
                        <SelectInput
                          source="isAdminApproved"
                          label="Admin Approval Status"
                          choices={currentStatusList}
                          InputLabelProps={{shrink: true}}
                          className={classes.highlightInput}
                          variant="outlined"
                          margin="dense"
                          disabled={isHist || role !== 'admin'}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Amount Requested (₹)"
                          value={`₹${fin.amountRequested.toLocaleString('en-IN')}`}
                          InputLabelProps={{shrink: true}}
                          className={classes.highlightInput}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Advance Amount (₹)"
                          value={`₹${fin.advanceAmount.toLocaleString('en-IN')}`}
                          InputLabelProps={{shrink: true}}
                          className={classes.highlightInput}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <NumberInput
                          source="amountToBePaid"
                          label="Agreed Amount (₹)"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                          disabled={isHist || role !== 'admin'}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Amount Paid (₹)"
                          value={`₹${fin.amountPaid.toLocaleString('en-IN')}`}
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextField
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                          label="Balance Amount (₹)"
                          value={`₹${fin.balanceAmount.toLocaleString('en-IN')}`}
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* 4. Project & Technical Details */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard}>
                  <Box className={classes.sectionHeader}>
                    <Avatar
                      style={{
                        backgroundColor: '#F0FDF4',
                        color: '#16A34A',
                        width: 26,
                        height: 26
                      }}
                    >
                      <BusinessIcon style={{fontSize: 16}} />
                    </Avatar>
                    <Typography className={classes.sectionTitle}>4. Project & Requirement Details</Typography>
                  </Box>
                  <CardContent className={classes.sectionContent}>
                    <Grid container spacing={1}>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="serviceCode"
                          label="Service Code"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="serviceId"
                          label="Service ID"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="serviceName"
                          label="Service Name"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="buildingType"
                          label="Building Type"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="noOfFloor"
                          label="No. of Floors"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <TextInput
                          disabled
                          source="plinthArea"
                          label="Plinth Area (Sq Ft)"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextInput
                          disabled
                          source="status"
                          label="Job Request Status"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextInput
                          disabled
                          multiline
                          minRows={2}
                          source="description"
                          label="Project Description & Notes"
                          InputLabelProps={{shrink: true}}
                          className={classes.inputFullWidth}
                          variant="outlined"
                          margin="dense"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* ROW 3: 5. Specific Scope & Requirements */}
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card className={classes.sectionCard}>
                  <Box className={classes.sectionHeader}>
                    <Avatar
                      style={{
                        backgroundColor: '#FEF3C7',
                        color: '#D97706',
                        width: 26,
                        height: 26
                      }}
                    >
                      <WorkIcon style={{fontSize: 16}} />
                    </Avatar>
                    <Typography className={classes.sectionTitle}>5. Specific Scope & Requirements</Typography>
                  </Box>
                  <CardContent className={classes.sectionContent}>
                    <Box style={{display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center'}}>
                      {reqFlags.map((flag) => {
                        const val = Boolean(currentRecord[flag.key]);
                        return (
                          <Chip
                            key={flag.key}
                            icon={val ? <CheckIcon style={{fontSize: 14}} /> : <CloseIcon style={{fontSize: 14}} />}
                            label={`${flag.label}: ${val ? 'Yes' : 'No'}`}
                            className={val ? classes.reqChipTrue : classes.reqChipFalse}
                          />
                        );
                      })}
                    </Box>
                    {currentRecord.isOthersRequired && currentRecord.otherRequirementDetails && (
                      <Box mt={1}>
                        <Typography variant="caption" style={{fontWeight: 700, color: '#475569'}}>
                          Other Requirement Details:
                        </Typography>
                        <Typography variant="body2" style={{color: '#0F172A', fontWeight: 600}}>
                          {currentRecord.otherRequirementDetails}
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        );
      }}
    </FormDataConsumer>
  );
};

const hasAnyUploadedImages = (record) => {
  if (!record) return false;
  const imageKeys = ['imagePath1', 'image1', 'imagePath2', 'image2', 'imagePath3', 'image3', 'imagePath4', 'image4'];
  return imageKeys.some((key) => Boolean(resolveUrl(record[key])));
};

const hasAnyUploadedDocuments = (record) => {
  if (!record) return false;
  const docKeys = ['documentPath1', 'documentPath2', 'documentPath3', 'documentPath4'];
  return docKeys.some((key) => Boolean(resolveUrl(record[key])));
};

const CustomImagesTabContent = ({record, classes}) => {
  const imageSlots = [
    { label: 'Image #1', keys: ['imagePath1', 'image1'] },
    { label: 'Image #2', keys: ['imagePath2', 'image2'] },
    { label: 'Image #3', keys: ['imagePath3', 'image3'] },
    { label: 'Image #4', keys: ['imagePath4', 'image4'] }
  ];

  const uploadedSlots = imageSlots.filter((slot) => {
    if (!record) return false;
    for (let key of slot.keys) {
      if (resolveUrl(record[key])) return true;
    }
    return false;
  });

  const slotsToRender = uploadedSlots.length > 0 ? uploadedSlots : imageSlots;

  return (
    <Box p={2}>
      <Typography variant="subtitle1" style={{fontWeight: 800, marginBottom: 12, color: '#000000'}}>
        Uploaded Project Images
      </Typography>
      <Grid container spacing={2}>
        {slotsToRender.map((slot) => {
          let rawUrl = null;
          if (record) {
            for (let key of slot.keys) {
              if (record[key]) {
                rawUrl = record[key];
                break;
              }
            }
          }
          const fullUrl = resolveUrl(rawUrl);
          const hasImg = Boolean(fullUrl);

          return (
            <Grid item xs={6} sm={3} key={slot.label}>
              <Card className={classes.mediaCard}>
                <Box mb={1} style={{display: 'flex', alignItems: 'center', gap: 6}}>
                  <ImageIcon color="primary" style={{fontSize: 18}} />
                  <Typography variant="caption" style={{fontWeight: 700, color: '#000'}}>
                    {slot.label}
                  </Typography>
                </Box>
                <Divider style={{width: '100%', marginBottom: 8}} />
                {hasImg ? (
                  <a
                    href={fullUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textDecoration: 'none', width: '100%'}}
                  >
                    <img
                      src={fullUrl}
                      alt={`Project ${slot.label}`}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '140px',
                        objectFit: 'contain',
                        borderRadius: '6px',
                        border: '1px solid #CBD5E1',
                        padding: '2px',
                        cursor: 'pointer'
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                        if (e.target.parentNode && e.target.parentNode.nextSibling) {
                          e.target.parentNode.nextSibling.style.display = 'block';
                        }
                      }}
                    />
                    <Typography className={classes.emptyPlaceholder} style={{display: 'none', marginTop: 8}}>
                      Failed to load image
                    </Typography>
                  </a>
                ) : (
                  <Box py={2}>
                    <Typography className={classes.emptyPlaceholder}>No image uploaded</Typography>
                  </Box>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const CustomDocumentsTabContent = ({record, classes}) => {
  const docSlots = [
    { label: 'Document #1', keys: ['documentPath1'] },
    { label: 'Document #2', keys: ['documentPath2'] },
    { label: 'Document #3', keys: ['documentPath3'] },
    { label: 'Document #4', keys: ['documentPath4'] }
  ];

  const uploadedDocSlots = docSlots.filter((slot) => {
    if (!record) return false;
    for (let key of slot.keys) {
      if (resolveUrl(record[key])) return true;
    }
    return false;
  });

  const slotsToRender = uploadedDocSlots.length > 0 ? uploadedDocSlots : docSlots;

  return (
    <Box p={2}>
      <Typography variant="subtitle1" style={{fontWeight: 800, marginBottom: 12, color: '#000000'}}>
        Uploaded Project Documents
      </Typography>
      <Grid container spacing={2}>
        {slotsToRender.map((slot) => {
          let rawUrl = null;
          if (record) {
            for (let key of slot.keys) {
              if (record[key]) {
                rawUrl = record[key];
                break;
              }
            }
          }
          const fullUrl = resolveUrl(rawUrl);
          const hasDoc = Boolean(fullUrl);

          return (
            <Grid item xs={6} sm={3} key={slot.label}>
              <Card className={classes.mediaCard}>
                <Box mb={1} style={{display: 'flex', alignItems: 'center', gap: 6}}>
                  <DescriptionIcon style={{color: '#4F46E5', fontSize: 18}} />
                  <Typography variant="caption" style={{fontWeight: 700, color: '#000'}}>
                    {slot.label}
                  </Typography>
                </Box>
                <Divider style={{width: '100%', marginBottom: 8}} />
                {hasDoc ? (
                  <Box style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, width: '100%'}}>
                    <DescriptionIcon style={{fontSize: 48, color: '#4F46E5'}} />
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      href={fullUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontSize: '0.75rem', textTransform: 'none'}}
                    >
                      View Document
                    </Button>
                  </Box>
                ) : (
                  <Box py={2}>
                    <Typography className={classes.emptyPlaceholder}>No document uploaded</Typography>
                  </Box>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const ProjectRequestsEditContent = ({classes, ...props}) => {
  const hasImages = hasAnyUploadedImages(props.record);
  const hasDocuments = hasAnyUploadedDocuments(props.record);

  return (
    <TabbedForm toolbar={<ProjectRequestsEditToolbar />} {...props}>
      <FormTab label="Details">
        <CustomDetailsTabContent classes={classes} />
      </FormTab>
      {hasImages && (
        <FormTab label="Images">
          <CustomImagesTabContent classes={classes} />
        </FormTab>
      )}
      {hasDocuments && (
        <FormTab label="Documents">
          <CustomDocumentsTabContent classes={classes} />
        </FormTab>
      )}
    </TabbedForm>
  );
};

const ProjectRequestsEdit = ({classes, ...props}) => (
  <Edit title="Edit Project Requests" {...props} actions={false}>
    <ProjectRequestsEditContent classes={classes} />
  </Edit>
);

export default withStyles(customStyles)(ProjectRequestsEdit);
